<button class="btn" type="button" (click)="openShopPage()">
    <i class="fa fa-shopping-cart" aria-hidden="true">
    </i>&nbsp;
    {{ buttonText }}
</button>